import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {LoginService} from '../login.service';
import { Router,RouterModule} from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { sha256, sha224 } from 'js-sha256';
import { ServerConstantsService } from '../serverConstants.service';

@Component({
  selector: 'app-appointments',
  templateUrl: './appointments.component.html',
  styleUrls: ['./appointments.component.css']
})
export class AppointmentsComponent implements OnInit {
  private gridApi;
  private gridColumnApi;
  defaultColDef = { resizable: true, cellStyle:{'font-size':'14px'} };
  columnDefs = [
    {headerName: 'Date & Time', field: 'date' },
    {headerName: 'Created By', field: 'createdBy' },
    {headerName: 'Type', field: 'type'},
    {headerName: 'Method', field: 'method'},
    {headerName: 'Location', field: 'office_name'},
    {headerName: 'Status', field: 'status'}
];

rowData = [];

  constructor(public toastService:ToastrService, public loginService:LoginService, public router:Router) {
    let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
    if(sessionStorage.getItem('status') !== undefined && CryptoJS.AES.decrypt(sessionStorage.getItem('status'), key).toString(CryptoJS.enc.Utf8) === 'SNAP RTW/Workfare'){
      this.router.navigate(['dashboard']);
    }
   }

  ngOnInit() {
    this.load();
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    //this.gridApi.setDomLayout("autoHeight");
  }
  load(){
    let request = {
      perId:this.loginService.personId
    };
    this.loginService.loadAppointments(request).subscribe((data:Array<Object>)=>{
      data.forEach((element)=>{
        Object.assign(element,{createdBy:element['first_name'] + ' ' +element['last_name']});
        Object.assign(element,{type:this.loginService.staticData.get("appointmentType").find(obj => obj.value == element['appointment_type']).name});
        Object.assign(element,{method:this.loginService.staticData.get("appointmentMethod").find(obj => obj.value == element['appointment_method_cd']).name});
        Object.assign(element,{status:this.loginService.staticData.get("appointmentStatus").find(obj => obj.value == element['appointment_status_cd']).name});
      })
      this.rowData = data;
    },error=>{
      this.toastService.error('Unable to load appointment summary','My Appointments');
    })
  }
  // changes for appointment request navigation on request of patrick.
  navigate(){
    this.loginService.requestType = 'AP';
    this.router.navigate(['requests/create']);
  }
  focus(event){
    if(event.keyCode == 9){
      event.preventDefault();
      this.gridApi.ensureIndexVisible(0);
      let firstCol = this.gridColumnApi.getAllDisplayedColumns()[0];
      this.gridApi.ensureColumnVisible(firstCol);
      this.gridApi.setFocusedCell(0, firstCol);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/appointments/appointments.component.ts